import Image from 'next/image';
import Icon from './helloeroBlack.svg?url';
import type { SvgImageProps } from '../_type';

export const HelloeroBlackImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={Icon} alt={alt} width={300} height={88} {...props} />;
